/* Detailing1 — "Frag die KI" Suchleisten-Button -> Intercom Messenger.
   Liest den Suchtext und oeffnet den Intercom-Chat mit vorbefuelltem Composer.
   Event-Delegation + Init-Guard: funktioniert in jedem Such-Formular (Header,
   Suchseite, mobil), ohne Doppel-Bindung. Layout-unabhaengig. */
(function () {
  if (window.__d1AiSearchChat) return;
  window.__d1AiSearchChat = true;

  function onClick(e) {
    var btn = e.target.closest('[data-ai-search-chat]');
    if (!btn) return;
    e.preventDefault();

    var form = btn.closest('form');
    var input = (form && form.querySelector('.js-search-input')) ||
                document.querySelector('.js-search-input');
    var text = input ? input.value.trim() : '';

    if (!text) {                       // leer -> Suchfeld fokussieren, kein leerer Chat
      if (input) input.focus();
      return;
    }

    if (typeof window.Intercom === 'function') {
      window.Intercom('showNewMessage', text);   // Composer vorbefuellen, Kunde sendet
    } else if (form) {
      form.submit();                   // Fallback: normale Suche, falls Messenger fehlt
    }
  }

  document.addEventListener('click', onClick);
})();
